const LOOPBACK_HOSTS = new Set(["localhost", "127.0.0.1", "[::1]", "::1"]);

/**
 * Web 游戏与承载它的官网共享登录存储，因此门户必须留在当前站点 origin。
 * APK 和本地开发运行在 loopback，那里没有官网页面，继续使用动态选出的官网地址。
 */
export function resolveGamePortalBaseUrl(configuredBaseUrl: string) {
  if (typeof window === "undefined") return configuredBaseUrl;

  try {
    const currentUrl = new URL(window.location.href);
    if (
      (currentUrl.protocol !== "http:" && currentUrl.protocol !== "https:") ||
      LOOPBACK_HOSTS.has(currentUrl.hostname)
    ) {
      return configuredBaseUrl;
    }
    return currentUrl.origin;
  } catch {
    // 测试桩或受限 WebView 可能没有完整 location；此时回退到已验证的运行时配置。
    return configuredBaseUrl;
  }
}
